import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const getRecaptcha = ({ commit, dispatch, state }, key) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`get/recaptcha`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const storeRecaptcha = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('store/recaptcha', data)
        .then((response) => {
          resolve(response)
        }).catch((err) => {
      reject(err)
    })
  })
}

  export const changeRecaptchaOnlineStatus = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
      window.axios.post('set/recaptcha/online', data).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(err)
      })
    })
  }



